/**
 * ULD标签管理相关常量定义
 */

// 预设颜色选项
export const PRESET_TAG_COLORS = [
    '#f50',      // 红色
    '#2db7f5',   // 蓝色
    '#87d068',   // 绿色
    '#108ee9',   // 深蓝
    '#f56a00',   // 橙色
    '#52c41a',   // 浅绿
    '#1890ff',   // 标准蓝
    '#fa541c',   // 橙红
    '#13c2c2',   // 青色
    '#722ed1',   // 紫色
    '#eb2f96',   // 粉红
    '#faad14',   // 黄色
];

// IATA状态码选项
export const IATA_STATUS_OPTIONS = [
    { value: 'AVL', label: 'AVL - 可用' },
    { value: 'DAM', label: 'DAM - 损坏' },
    { value: 'SRV', label: 'SRV - 受限可用' },
    { value: 'UNS', label: 'UNS - 不可用' },
    { value: 'RIP', label: 'RIP - 维修中' },
    { value: 'HLD', label: 'HLD - 留置/隔离' },
    { value: 'SLV', label: 'SLV - 可修复/待回收' },
    { value: 'SCR', label: 'SCR - 已报废' },
    { value: 'LOST', label: 'LOST - 丢失' },
];

// 默认系统标签
export const DEFAULT_SYSTEM_TAGS = [
    {
        tag_name: '维修中',
        description: '设备正在维修，不可使用',
        color_code: '#f50',
        iata_equivalent_status: 'RIP'
    },
    {
        tag_name: '破损-轻微',
        description: '设备有轻微破损，但仍可使用',
        color_code: '#fa541c',
        iata_equivalent_status: 'SRV'
    },
    {
        tag_name: '待清洗',
        description: '设备需要清洗',
        color_code: '#13c2c2',
        iata_equivalent_status: 'SRV'
    },
    {
        tag_name: '客户专用',
        description: '特定客户专用设备',
        color_code: '#722ed1',
        iata_equivalent_status: null
    },
    {
        tag_name: '高频使用',
        description: '使用频率较高的设备',
        color_code: '#52c41a',
        iata_equivalent_status: null
    }
];

// 表格列配置
export const TAG_TABLE_COLUMNS = [
    'tag_name',
    'description',
    'color_code',
    'iata_equivalent_status',
    'is_system_tag',
    'created_at',
    'actions'
];

// 分页配置
export const DEFAULT_TAG_PAGE_SIZE = 20; 